import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseSiteService } from '@spartacus/core';
import { EnvironmentService } from '../../services/environment.service';
import { ScriptService } from '../../services/script.service';

@Component({
  selector: 'app-chat-widget',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GgChatWidgetComponent implements AfterViewInit {
  private baseSiteService = inject(BaseSiteService);
  private environmentService = inject(EnvironmentService);
  private destroyRef = inject(DestroyRef);
  private scriptService = inject(ScriptService);

  ngAfterViewInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((baseSite) => {
        if (!baseSite) return;

        const environment = this.environmentService.getCurrentEnvironment() as any;
        const chatConfig = environment?.chat;

        // Load LiveChat
        if (chatConfig?.liveChat?.[baseSite]) {
          this.scriptService.loadScript('livechat');
        }

        // Load JivoChat
        if (baseSite && chatConfig?.jivoChat?.[baseSite]) {
          this.scriptService.loadScript('jivochat');
        }

        // Load Freeday Chat
        this.loadFreedayScript(chatConfig?.freeday?.[baseSite]);
      });
  }

  private loadFreedayScript(channelId: string | undefined): void {
    if (!channelId || channelId === '') {
      return;
    }

    const template = `
      (async () => {
        const response = await fetch('https://api.freeday.ai/webchat/v1/widget/${channelId}');
        if (!response.ok) throw new Error('Failed to fetch Freeday configuration');
        const freedayConfiguration = await response.json();
        const freedayWidget = await import(freedayConfiguration.cdnUrl);
        freedayWidget.bootstrap(freedayConfiguration);
      })();
      `;

    this.scriptService.loadScriptTemplate('freeday', template);
  }
}
